import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import SupportServicesDetail from '@src/features/company/support-services/SupportServiceShow';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';
import { useState } from 'react';

function CompanySupportServicesDetail() {
  const [feature, setFeature] = useState('');
  const [description, setDescription] = useState('');

  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}>
      <CompanyDefaultLayout pageName='support-services'>
        <CommonHelmet
          feature={feature}
          description={description}
        />
        <SupportServicesDetail
          setFeature={setFeature}
          setDescription={setDescription}
        />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanySupportServicesDetail;
